import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import cn from "classnames";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";
import classes from "./PreviewRegister.module.scss";
import Validation from "@/components/common/Validation/Validation";
import useRegister from "@/hooks/user/register/useRegister";
import { useIANATimezoneDatabase, useRegisterTrack, useUserState } from "@/states/user.state";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { BiLoaderAlt } from "react-icons/bi";
import { useError } from "@/states/common.state";
import { useTranslations } from "next-intl";
import { isValidEmail, returnErrorAsString } from "@/helper/helper";
import { GoArrowLeft } from "react-icons/go";
import { SignupModalIds } from "@/constant";
import { cookiePersistStorage } from "@/helper/common.helper";
const PreviewRegister = ({
  closeModalInPreview
}: {
  closeModalInPreview: () => void;
}) => {
  const router = useRouter();
  const {
    query
  } = router;
  const {
    email
  } = query;
  const {
    trackProperty,
    setRegisterTrack
  } = useRegisterTrack();
  const {
    timeZoneDb
  } = useIANATimezoneDatabase();
  const {
    typedEmail
  } = useUserState();
  const t = useTranslations("LoginAndSignup");
  const access_token = cookiePersistStorage.getItem("access_token");
  const handleRegisterTrack = () => {
    if (!trackProperty) setRegisterTrack("/register");
  };
  const {
    error,
    setError,
    setDeleteError
  } = useError();
  const [isConfirmEye, setIsConfirmEye] = useState<boolean>(false);
  const hooksForm = useForm({
    defaultValues: {
      email,
      password: ""
    }
  });
  const {
    setMutate,
    isLoading
  } = useRegister();
  const onSubmit = (data: any) => {
    if (!isLoading) {
      setMutate({
        ...data,
        register_tracker: trackProperty,
        timezone: timeZoneDb
      });
    }
  };
  const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.currentTarget;
    if (isValidEmail(value) && error) {
      setDeleteError(name);
    }
  };
  const handleChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name
    } = e.currentTarget;
    if (hooksForm.watch().password?.length > 8 && error) {
      setDeleteError(name);
    }
  };
  useEffect(() => {
    if (access_token) {
      router.reload();
    }
    setError(null);
    cookiePersistStorage.setItem("auth_intent", "register");
  }, []);
  return <motion.div initial={{
    y: 100,
    opacity: 0
  }} id={SignupModalIds.E.signup_modal_wrapper} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    ease: "linear",
    duration: 0.2
  }} className={classes.Wrapper} data-sentry-element="unknown" data-sentry-component="PreviewRegister" data-sentry-source-file="PreviewRegister.tsx">
      <div className={classes.Content}>
        <div>
          <div className={classes.Title}>
            <GoArrowLeft onClick={closeModalInPreview} color="#A1A1A1" size={24} data-sentry-element="GoArrowLeft" data-sentry-source-file="PreviewRegister.tsx" />
            <span>Your QR Code is just a click away!</span>
          </div>
          <form id={SignupModalIds.E.btn_signup_modal_form_submit} onSubmit={hooksForm.handleSubmit(onSubmit)}>
            <div className={classes.InputBox}>
              <label htmlFor="email" className={classes.InputTitle}>
                {t("emailAddress")}
              </label>
              <div className={classes.InputWrapper}>
                <input id="email" {...hooksForm.register("email", {
                onChange: handleChangeEmail
              })} type={"text"} className={cn(classes.Input, returnErrorAsString("email", "formInput"))} placeholder={t("exampleEmail")} defaultValue={typedEmail !== "" ? typedEmail : ""} />
                <span className={classes.errors}>
                  <Validation type="email" icon data-sentry-element="Validation" data-sentry-source-file="PreviewRegister.tsx" />
                </span>
              </div>
            </div>
            <div className={cn(classes.InputBox, classes.InputPassword)}>
              <label htmlFor="password" className={classes.InputTitle}>
                {t("password")}
              </label>
              <div className={classes.InputWrapper}>
                <input id="password" {...hooksForm.register("password", {
                onChange: handleChangePassword
              })} type={!isConfirmEye ? "password" : "text"} className={cn(classes.Input, classes.PasswordInput, returnErrorAsString("password", "formInput"))} placeholder={t("passwordHint")} />
                <span className={classes.Eye} onClick={() => setIsConfirmEye(!isConfirmEye)}>
                  {!isConfirmEye ? <AiOutlineEyeInvisible color="#A1A1A1" size={22} /> : <AiOutlineEye color="#A1A1A1" size={22} />}
                </span>
                <span className={classes.errors}>
                  <Validation type="password" icon data-sentry-element="Validation" data-sentry-source-file="PreviewRegister.tsx" />
                </span>
              </div>
            </div>
            <button id={SignupModalIds.E.btn_signup_modal_register} className={classes.SubmitButton} onClick={handleRegisterTrack} disabled={isLoading}>
              {isLoading ? <BiLoaderAlt color={"#ffffff"} size={20} /> : "Get Your QR Code"}
            </button>
          </form>
          <span className={classes.terms}>
            By clicking “Get Your QR Code” you agree to our{" "}
            <a target="_blank" href="/terms">
              T&C.
            </a>
          </span>
        </div>
      </div>
    </motion.div>;
};
export default PreviewRegister;